import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuard  {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const isLogout = new URLSearchParams(window.location.search).get('isLogout');
  const resetToDefault = new URLSearchParams(window.location.search).get('resetToDefault');
  if(isLogout || resetToDefault) {
    localStorage.clear();
  }

    const isMultipleSubscription=localStorage.getItem('isMultipleSubscription');
    let isAuth = this.authService.isAuthenticated();
    if (!isAuth ||isMultipleSubscription==="false") {
      const isCustomer = localStorage.getItem("isCustomer");
      const companyPreferences = JSON.parse(
        localStorage.getItem("companyPrefrences")
      );
      const companyNickName = companyPreferences?.nickName;
      const isCustomerLogin = isCustomer && companyNickName;
      const loginUrl = isCustomerLogin ? companyNickName : "login";
      this.router.navigate([loginUrl]);
    }
    else {
      return true;
    }
  }
}
